import {
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { UserData } from '../model/response/user-data';
import { userApi } from '../administration/user-api';

export interface UserState {
  all: {
    data: UserData[];
    status: 'idle' | 'loading' | 'ready' | 'failed';
  };
}

const initialState: UserState = {
  all: {
    data: [],
    status: 'idle',
  },
};
// const initialState: UserData = {
//   id: '',
//   deptCode: '',
//   deptName: '',
//   parentId: '',
//   parentName: '',
// };

export const getAllUser = createAsyncThunk(
  'user/all',
  async (arg, { getState }) => {
    const state = getState() as RootState;
    if (state.user.all.status === 'idle') {
      const res = await userApi.getUsers();
      return res;
    }
  },
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // .addCase(getAllUser.pending, state => {
      //   state.all.status = 'loading';
      // })
      .addCase(
        getAllUser.fulfilled,
        (state, action: any) => {
          if (action.payload) {
            state.all = {
              data: action.payload,
              status: 'ready',
            };
          }
          // state.all.status = 'ready';
        },
      );
    // .addCase(getAllUser.rejected, state => {
    //   state.all.status = 'failed';
    // });
  },
});

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
